import React, { HTMLAttributeAnchorTarget } from 'react';

interface LinkProps {
	targetType?: 'tab' | 'popup';
	onClick?: () => void;
	redirectUrl?: string;
	target?: HTMLAttributeAnchorTarget;
	children?: React.ReactNode;
}

export const Link: React.FC<LinkProps> = (props) => {
	const { targetType = 'tab', redirectUrl, target, children, onClick } = props;

	const handlePopupLinkOnClick = () => {
		window.open(redirectUrl, target, 'width=4000,height=4000');
	};

	return (
		<>
			{targetType === 'tab' ? (
				<a onClick={onClick} href={redirectUrl} target={target} style={{ cursor: 'pointer' }}>
					{children}
				</a>
			) : (
				<a
					onClick={() => handlePopupLinkOnClick()}
					href={redirectUrl}
					target={target}
					style={{ cursor: 'pointer' }}
				>
					{children}
				</a>
			)}
		</>
	);
};
